<template>
    <div class="page" ref="page">
        <div class="top">
            <div class="top-section top-review">
                <img v-if="dataList.productInfo" :src="dataList.productInfo.productImage" class="img" alt="" />
                <div class="infomate">
                    <div class="title">{{ dataList.brandInfo && dataList.brandInfo.brandName }}出品</div>
                    <div class="line">_</div>
                    <h6 class="subtitle">{{ dataList.productInfo && dataList.productInfo.productName }}</h6>
                    <div class="btn" @click="toPage">
                        了解{{ (dataList.brandInfo && dataList.brandInfo.brandName) || '详情' }}>
                    </div>
                </div>
                <p class="tip">经扫描核实，您购买的是{{ dataList.brandInfo && dataList.brandInfo.brandName }}产品</p>
            </div>
            <div class="top-section top-list">
                <ul class="list-box">
                    <li v-for="(item, index) in details" :key="item.name">
                        <div
                            class="lis-item"
                            v-if="index === details.length - 2 || details.length - 1 ? detailsTime[index] : true"
                        >
                            <span class="lis-item-name">
                                <img :src="item.icon" class="icon" alt="" />
                                {{ item.name }}
                            </span>
                            <label v-if="detailsTime[index]">{{ detailsTime[index] }}</label>
                        </div>
                    </li>

                    <li v-if="dataList.transportInfo && dataList.transportInfo.transportType === 2">
                        <div class="lis-item">
                            <span class="lis-item-name">
                                <img class="icon" :src="require('@/assets/image/review/peisongjilu.svg')" alt="" />
                                产地直销
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <van-sticky class="review-tab">
            <ul class="tab-box">
                <li
                    class="tab-item"
                    v-for="(item, index) in tabs"
                    :key="item"
                    :class="{ active: active === index }"
                    @click="toLinkScroll(item, index)"
                >
                    {{ item }}
                </li>
            </ul>
        </van-sticky>

        <div class="review-box">
            <!--产地信息-->
            <div :ref="lisName[0]" class="list-review source">
                <h6 class="title">
                    <div>
                        产地信息
                    </div>
                    <div
                        class="to-origin"
                        @click="toVerify"
                        v-if="
                            dataList.batchInfo.accuracy ||
                                dataList.batchInfo.isotope ||
                                dataList.batchInfo.multiElements ||
                                dataList.batchInfo.originName ||
                                dataList.batchInfo.othersRemark ||
                                dataList.batchInfo.verifyTime
                        "
                    >
                        原产地验证
                        <van-icon name="arrow" />
                    </div>
                </h6>

                <div class="card">
                    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                        <van-swipe-item style="height:274px;">
                            <div class="productInfo">
                                <h6 class="title">
                                    <img :src="require('@/assets/image/review/tag.svg')" alt="" />
                                    {{ dataList.productInfo && dataList.productInfo.formatAddress }}
                                </h6>
                                <div id="container" class="map"></div>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item v-for="item in originImage" :key="item + 'x'" style="height:274px;">
                            <img :src="item" alt="" style="width:100%;height:100%;object-fit:cover;" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>

            <!--种植流程-->
            <div :ref="lisName[1]" class="list-review">
                <h6 class="title">
                    种植流程
                    <van-icon name="arrow" @click="toFlow('planting')" />
                </h6>
                <div class="imgs" v-if="dataList.plantingInfo && dataList.plantingInfo.plantingNodes">
                    <span class="img-box" v-for="(item, index) in dataList.plantingInfo.plantingNodes" :key="item.id">
                        <img
                            v-if="
                                index === 0 ||
                                    index === 1 ||
                                    index === dataList.plantingInfo.plantingNodes.length - 2 ||
                                    index === dataList.plantingInfo.plantingNodes.length - 1
                            "
                            :key="item.id"
                            :src="item.imgList[0]"
                            class="img-item"
                            alt=""
                        />
                    </span>
                </div>
                <p class="bottom-btn">
                    <van-divider :dashed="true" class="divider" :style="{ borderColor: '#1989fa', color: '#008A6A' }">
                        <van-button type="primary" class="btn left-btn">开始</van-button>
                        <span class="center-font btn">
                            {{ (dataList.plantingInfo && dataList.plantingInfo.plantingNodes.length) || 0 }}个步骤
                        </span>
                        <van-button type="primary" class="btn right-btn">收获</van-button>
                    </van-divider>
                </p>
            </div>

            <!--加工流程-->
            <div :ref="lisName[2]" class="list-review">
                <h6 class="title">
                    加工流程
                    <van-icon name="arrow" @click="toFlow('process')" />
                </h6>
                <div class="imgs" v-if="dataList.processInfo && dataList.processInfo.processNodes">
                    <span class="img-box" v-for="(item, index) in dataList.processInfo.processNodes" :key="item.id">
                        <img
                            v-if="
                                index === 0 ||
                                    index === 1 ||
                                    index === dataList.processInfo.processNodes.length - 2 ||
                                    index === dataList.processInfo.processNodes.length - 1
                            "
                            :key="item.id"
                            :src="item.imgList[0]"
                            class="img-item"
                            alt=""
                        />
                    </span>
                </div>
                <p class="bottom-btn">
                    <van-divider :dashed="true" class="divider" :style="{ borderColor: '#1989fa', color: '#008A6A' }">
                        <van-button type="primary" class="btn left-btn">开始</van-button>
                        <span class="center-font btn">
                            {{ (dataList.processInfo && dataList.processInfo.processNodes.length) || 0 }}个步骤
                        </span>
                        <van-button type="primary" class="btn right-btn">结束</van-button>
                    </van-divider>
                </p>
            </div>

            <!--原料储存情况-->
            <div
                :ref="lisName[3]"
                class="list-review store"
                v-if="dataList.productInfo && dataList.productInfo.brandName.indexOf('苹果') == -1"
            >
                <h6 class="title">原料储存情况</h6>
                <ul class="content">
                    <li class="item item-after">
                        入仓时间
                        <span class="num">
                            {{
                                dataList.batchInfo &&
                                    dataList.batchInfo.storageEntryDate &&
                                    moment(dataList.batchInfo.storageEntryDate).format('YYYY/MM/DD')
                            }}
                        </span>
                    </li>
                    <li class="item item-after">
                        仓储温度
                        <span class="num">{{ dataList.batchInfo && dataList.batchInfo.storageTemp }}℃</span>
                    </li>
                    <li class="item">
                        仓储水分
                        <span class="num">{{ dataList.batchInfo && dataList.batchInfo.storageHumidity }}%</span>
                    </li>
                </ul>
            </div>

            <!--产品质量检测-->
            <div :ref="lisName[4]" class="list-review check">
                <h6 class="title">产品质量检测</h6>
                <van-swipe :loop="false">
                    <van-swipe-item
                        ref="vanSwipeItem"
                        v-for="(item, index) in planting"
                        :key="item.url + index"
                        style="text-align: center"
                    >
                        <img
                            :src="item.url"
                            class="swipe-img"
                            :style="{ width: widthVan / 1.1 + 'px' }"
                            style="object-fit: cover"
                        />
                    </van-swipe-item>
                </van-swipe>

                <p
                    class="product-info content"
                    v-if="dataList.detectionInfo && dataList.detectionInfo.detectConditions"
                >
                    <span class="item" v-for="item in dataList.detectionInfo.detectConditions" :key="item.condition">
                        <img src="@/assets/image/review/he.svg" class="icon" alt="" />
                        <br />
                        {{ item.condition }}
                        <label>
                            {{ item.symbol }}
                            <b>
                                {{ item.value }}
                                <span v-if="item.condition != '新鲜度'">%</span>
                            </b>
                        </label>
                    </span>
                    <span class="item qualifie">
                        <img src="@/assets/image/review/he.svg" class="icon" alt="" />
                        <br />
                        合格
                        <label>
                            <b>{{ (dataList.detectionInfo && dataList.detectionInfo.detectResult) || '' }}</b>
                        </label>
                    </span>
                </p>
            </div>

            <img
                v-if="dataList.brandInfo && dataList.brandInfo.feedbackImage"
                :src="dataList.brandInfo.feedbackImage"
                class=""
                style="width:100%;object-fit:cover;"
            />
        </div>
        <van-image-preview v-model="show" :images="images">
            <!--<template v-slot:index>第{{ index }}页</template>-->
        </van-image-preview>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import getConf from '../../../config/env'
import Vue from 'vue'
import { Lazyload, ImagePreview } from 'vant'
Vue.use(Lazyload)
Vue.use(ImagePreview)

export default {
    data() {
        return {
            moment,
            active: 0,
            detailsTime: [],
            details: [
                {
                    name: '种植时间',
                    icon: require('@/assets/image/review/nongshi.svg'),
                },
                {
                    name: '原料到仓时间',
                    icon: require('@/assets/image/review/kucunchaxun.svg'),
                },
                {
                    name: '加工时间',
                    icon: require('@/assets/image/review/jiagongjilu.svg'),
                },
                {
                    name: '运输时间',
                    icon: require('@/assets/image/review/ruku.svg'),
                },
                {
                    name: '成品入库时间',
                    icon: require('@/assets/image/review/peisongjilu.svg'),
                },
            ],
            packDetail: [
                {
                    name: '包装尺寸',
                    value: '30cm*4cm*53cm',
                },
                {
                    name: '包装类型',
                    value: '真空包装',
                },
                {
                    name: '执行标准',
                    value: 'NY/T 419',
                },
            ],
            tabs: ['原产地', '生产流程', '加工过程', '仓储信息', '检验报告'],
            lisName: ['source', 'plant', 'process', 'store', 'check'],
            elementOffsetTop: [], //元素偏移量
            dataList: {},
            planting: [],
            show: false,
            images: [],
            widthVan: 200,
            originImage: [],
            plantingNodesImg: [],
            lonlat: [120.2, 30.3],
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    mounted() {
        const { id } = this.$route.query || {}
        if (id) {
            this.getInfo(id)
        } else {
            this.$notify('未查询到批次id')
        }

        if (document.body.clientWidth > 450) {
            this.widthVan = 500
        } else if (document.body.clientWidth < 350) {
            this.widthVan = 160
        }

        // 元素的偏移量
        this.lisName.forEach(value => {
            this.elementOffsetTop.push(this.$refs[value].offsetTop)
        })
        window.addEventListener('scroll', this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    },
    methods: {
        getInfo(id) {
            let url = getConf().reviewBaseUrl
            url += `/api/batchInfo/scan/${id}`
            axios.get(url).then(res => {
                this.dataList = { ...(res.data.data || {}) }
                this.makeData()
                // this.drawMap()
                this.planting = (this.dataList.detectionInfo && this.dataList.detectionInfo.images) || []
                this.planting = [...this.planting, ...this.planting]
                if (this.dataList.productInfo && this.dataList.productInfo.longitude) {
                    this.lonlat = [this.dataList.productInfo.longitude, this.dataList.productInfo.latitude]
                    this.lonlat = [...this.lonlat]
                }
                this.$nextTick(() => {
                    this.drawMap()
                })
            })
        },
        drawMap() {
            var map = new AMap.Map('container', {
                center: this.lonlat,
                layers: [
                    //使用多个图层
                    new AMap.TileLayer.Satellite(),
                    // new AMap.TileLayer.RoadNet()
                ],
                zooms: [4, 18], //设置地图级别范围
                zoom: 10,
                dragEnable: false,
                zoomEnable: false,
            })
            // 创建一个 Marker 实例：
            var marker = new AMap.Marker({
                icon: require('@/assets/image/review/position.svg'),
                position: new AMap.LngLat(this.lonlat[0], this.lonlat[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                // animation: 'AMAP_ANIMATION_BOUNCE',
                offset: new AMap.Pixel(-10, -5),
                title: this.dataList.productInfo.formatAddress || '',
            })
            // 将创建的点标记添加到已有的地图实例：
            map.add(marker)
        },
        makeData() {
            let data = this.dataList
            this.detailsTime = []
            let formatString = 'YYYY年MM月DD日'
            if (data.plantingInfo) {
                this.detailsTime.push(
                    //种植开始时间-种植结束时间
                    moment(data.plantingInfo.startDate).format(formatString) +
                        '-' +
                        moment(data.plantingInfo.endDate).format(formatString)
                )
            }
            //苹果就不显示原料到仓时间和加工时间
            if (this.dataList.productInfo && this.dataList.productInfo.brandName.indexOf('苹果') == -1) {
                if (data.batchInfo && data.batchInfo.storageEntryDate) {
                    this.detailsTime.push(
                        //原料到仓时间
                        moment(data.batchInfo.storageEntryDate).format(formatString)
                    )
                }
                if (data.batchInfo && data.batchInfo.processStartDate) {
                    this.detailsTime.push(
                        //加工时间
                        moment(data.batchInfo.processStartDate).format(formatString)
                    )
                }
            }

            // transportType: 1:入仓   2:产地直发
            if (data.transportInfo && data.transportInfo.transportType === 1) {
                if (data.transportInfo && data.transportInfo.outputDate) {
                    this.detailsTime.push(
                        //运输时间
                        moment(data.transportInfo.outputDate).format(formatString)
                    )
                }
                if (data.transportInfo && data.transportInfo.inputDate) {
                    this.detailsTime.push(
                        //成品入库时间
                        moment(data.transportInfo.inputDate).format(formatString)
                    )
                }
            }

            /*
             * 图片处理
             * */
            //种植流程
            if (this.dataList.plantingInfo && this.dataList.plantingInfo.plantingNodes) {
                this.dataList.plantingInfo.plantingNodes.forEach(value => {
                    value.imgList = (value.image && JSON.parse(value.image)) || []
                })
            }
            //加工流程
            if (this.dataList.processInfo && this.dataList.processInfo.processNodes) {
                this.dataList.processInfo.processNodes.forEach(value => {
                    value.imgList = (value.image && JSON.parse(value.image)) || []
                })
            }
            //产地图片
            if (this.dataList.productInfo && this.dataList.productInfo.originImage) {
                this.originImage = [...(JSON.parse(this.dataList.productInfo.originImage) || [])]
            }
        },
        handleScroll() {
            let { elementOffsetTop } = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            // 元素的偏移量
            if (scrollTop <= elementOffsetTop[1] - 100) {
                this.active = 0
            } else if (scrollTop <= elementOffsetTop[2] - 100) {
                this.active = 1
            } else if (scrollTop <= elementOffsetTop[3] - 100) {
                this.active = 2
            } else if (scrollTop <= elementOffsetTop[4] - 200) {
                this.active = 3
            }
        },
        toLinkScroll(item, index) {
            window.removeEventListener('scroll', this.handleScroll)
            this.active = index
            this.$refs[this.lisName[index]].scrollIntoView()
            setTimeout(() => {
                window.addEventListener('scroll', this.handleScroll)
            }, 0)
        },
        toPage() {
            console.log(this.dataList.brandInfo.image)
            this.$router.push({
                name: 'reviewDetail',
                query: {
                    imgUrl: this.dataList.brandInfo.image || '',
                },
            })
        },
        toFlow(name) {
            this.$router.push({
                name: 'reviewFlow',
                query: {
                    list: JSON.stringify(this.dataList[`${name}Info`][`${name}Nodes`]),
                },
            })
        },
        toVerify() {
            this.$router.push({
                name: 'originVerify',
                query: {
                    info: JSON.stringify(this.dataList.batchInfo),
                },
            })
        },
        // handleOption() {
        //     let element = document.getElementsByClassName('check-img')
        //     for(let i=0; i< element.length; i++) {
        //         let min = 40, middle = 55, max = 155, maxFlag = 155
        //         if(document.body.clientWidth <= 365){
        //             maxFlag = 120
        //         }
        //         //重置
        //         let left = element[i].offsetLeft
        //         element[i].style.top = 0
        //         element[i].style['z-index'] = 1
        //         if(left <= 0) {   //中间位置
        //             element[i].style.top = '-10%'
        //             element[i].style['z-index'] = 5
        //             element[i].style.left = `${middle/3.75 }vw`
        //         }else if(left >= maxFlag){ //最左边
        //             element[i].style.left = `-${min/3.75}vw`
        //         }else {  //最右边
        //             element[i].style.left = `${max/3.75}vw`
        //         }
        //     }
        // },
        // handleImage() {
        //     this.show = true
        //     this.images = []
        //     this.planting.forEach(value=>{
        //         this.images.push(value.url)
        //     })
        // }
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/review/index';
@import '../../styles/common.scss';

.to-origin {
    font-size: pxtovw(14);
    padding: pxtovw(2) pxtovw(8);
    background-color: #f8a23d;
    color: #fff;
    display: flex;
    align-items: center;
    border-radius: pxtovw(2);
}
</style>
